import { LoadingOverlay } from '@mantine/core'
import { translate } from 'i18n/i18n'
import { useEffect, useState } from 'react'
import { colors } from 'settings/colors'
import { useIsWideScreen } from 'utils/useIsWideScreen'
import { SettingsCreateNewButton } from '../../components/SettingsCreateNewButton/SettingsCreateNewButton'
import { SettingsFooterContainer } from '../../components/SettingsFooterContainer/SettingsFooterContainer'
import { SettingsSearchNotFound } from '../../components/SettingsSearchNotFound/SettingsSearchNotFound'
import { ItemHeader } from '../../WideScreen/ItemHeader/ItemHeader'
import { useGroupsAndContacts } from '../ContactsAndGroups/ContactsAndGroupsContext'
import type { AlertWithPossibleId } from './_types'
import { useAlerts } from './_utils/useAlerts'
import { AlertCard } from './components/AlertCard/AlertCard'
import { useSearchAlerts } from './components/useSearchAlerts'
import { ModalDrawerCreateOrEditAlert } from './ModalDrawerCreateOrEditAlert/ModalDrawerCreateOrEditAlert'

export type TModalDrawerForm = 'createAlert' | 'editAlert' | null

export const Alerts = () => {
  const [modalDrawerForm, setModalDrawerForm] = useState<TModalDrawerForm>(null)
  const isWideScreen = useIsWideScreen()
  const [selectedAlert, setSelectedAlert] = useState<AlertWithPossibleId | null>(null)
  const { alerts, loading, refreshHandle: refreshAlerts, deleteAlertHandler } = useAlerts()
  const { initializeContactsAndGroups, loading: groupsAndContactsLoading } = useGroupsAndContacts()

  const { SearchInputComponent, filteredAndSortedList, isSearchMatch } = useSearchAlerts({
    initialList: alerts,
    placeholder: translate.phrases.banyanApp('Search Alerts'),
  })

  useEffect(() => {
    initializeContactsAndGroups()
  }, [])

  return (
    <>
      <LoadingOverlay visible={loading || groupsAndContactsLoading} />
      <ItemHeader>{translate.phrases.banyanApp('Alerts')}</ItemHeader>
      <div css={{ margin: '0px 20px', paddingBottom: 60 }}>
        {isWideScreen && (
          <div css={{ textAlign: 'right', marginBottom: 20 }}>
            <SettingsCreateNewButton
              label={translate.phrases.banyanApp('New Alert')}
              onClick={() => {
                setModalDrawerForm('createAlert')
              }}
            />
          </div>
        )}
        {alerts.length === 0 && (
          <div
            css={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginTop: 20,
              borderTop: `1px solid ${colors.grey200}`,
              padding: 20,
              marginBottom: 5,
            }}
          >
            {translate.phrases.banyanApp('No alerts are added yet.')}
          </div>
        )}
        {alerts.length > 0 && SearchInputComponent}
        {isSearchMatch ? (
          filteredAndSortedList.map((alert) => (
            <AlertCard
              key={alert.id}
              alert={alert}
              setSelectedAlert={setSelectedAlert}
              setModalDrawerForm={setModalDrawerForm}
              postDeleteHandler={deleteAlertHandler}
            />
          ))
        ) : (
          <SettingsSearchNotFound />
        )}
      </div>
      {!isWideScreen && (
        <SettingsFooterContainer>
          <SettingsCreateNewButton
            label={translate.phrases.banyanApp('New Alert')}
            onClick={() => {
              setModalDrawerForm('createAlert')
            }}
            css={{ width: '100%' }}
          />
        </SettingsFooterContainer>
      )}
      <ModalDrawerCreateOrEditAlert
        opened={modalDrawerForm !== null}
        onClose={() => {
          setModalDrawerForm(null)

          setSelectedAlert(null)
        }}
        alertId={selectedAlert?.id ?? null}
        selectedAlert={selectedAlert}
        refreshAlerts={refreshAlerts}
      />
    </>
  )
}
